import React__default from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Tag } from '../../display/Tag/Tag.es.js';
import { Grid } from '../../layout/Grid/Grid.es.js';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';
import { Link } from '../../navigation/Link/Link.es.js';
import { clsx } from 'clsx';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';

const root = "_root_1amgd_1";
const container = "_container_1amgd_17";
const content = "_content_1amgd_35";
const labelContainer = "_label-container_1amgd_46";
const media = "_media_1amgd_51";
const heading = "_heading_1amgd_66";
const description = "_description_1amgd_95";
const cta = "_cta_1amgd_105";
const secondaryCta = "_secondary-cta_1amgd_117";
const styles = {
	root: root,
	container: container,
	content: content,
	labelContainer: labelContainer,
	media: media,
	heading: heading,
	description: description,
	cta: cta,
	secondaryCta: secondaryCta
};

const TwoColumnRiver = ({ backgroundColor = "neutral100", ctaColor = "primary", ctaHref, ctaText, ctaTarget, description, heading, isReversed = false, media, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaHref, secondaryCtaText, label, labelIcon, labelColor, className }) => {
  const getCtaComponent = () => {
    const sharedProps = {
      children: ctaText,
      href: ctaHref,
      onClick: onCtaClick,
      onKeyDown: onCtaKeyDown,
      target: ctaTarget
    };
    return React__default.createElement(LegacyButton, Object.assign({}, sharedProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: ctaColor === "primary-alt" ? "primary" : ctaColor
    }));
  };
  return React__default.createElement(
    "div",
    { className: clsx(styles.root, className), style: {
      "--_zds-twocolumnriver-background-color": Colors[LegacyColorMap[backgroundColor]]
    }, "data-zds": true },
    React__default.createElement(
      "div",
      { className: clsx(styles.container, "twoColumnRiver-container"), "data-reversed": isReversed ? true : void 0, "data-zds": true },
      React__default.createElement(
        "div",
        { className: clsx(styles.content, "twoColumnRiver-content"), "data-zds": true },
        label && React__default.createElement(
          "div",
          { className: clsx(styles.labelContainer, "twoColumnRiver-labelContainer"), "data-zds": true },
          React__default.createElement(Tag, { variant: labelColor }, labelIcon ? React__default.createElement(
            Grid,
            { alignItems: "center", columns: "auto max-content", gap: 5 },
            React__default.createElement(Icon, { name: labelIcon, size: 20 }),
            label
          ) : label)
        ),
        React__default.createElement(
          HeadingLevel,
          null,
          React__default.createElement(Heading, { className: styles.heading }, heading)
        ),
        description && React__default.createElement("div", { className: clsx(styles.description, "twoColumnRiver-description"), "data-zds": true }, description),
        ctaText && (ctaHref || onCtaClick) && React__default.createElement("div", { className: clsx(styles.cta, "twoColumnRiver-cta"), "data-zds": true }, getCtaComponent()),
        secondaryCtaText && secondaryCtaHref && React__default.createElement(
          "div",
          { className: clsx(styles.secondaryCta, "twoColumnRiver-secondaryCta"), "data-zds": true },
          React__default.createElement(Link, { href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" }, secondaryCtaText)
        )
      ),
      media && React__default.createElement("div", { className: clsx(styles.media, "twoColumnRiver-media"), "data-reversed": isReversed ? true : void 0, "data-zds": true }, media)
    )
  );
};

export { TwoColumnRiver };
//# sourceMappingURL=TwoColumnRiver.es.js.map
